import React, { useState } from 'react';
import NumericInput from 'react-numeric-input';
import { withTranslation } from 'react-i18next';
import InputMenor from './edad';

const Habitacion = ({
  actualizarEdadesMenores,
  actualizarAdultos,
  actualizarMenores,
  habitacion,
  listaHabitaciones,
  t,
}) => {
  const [adultos, setAdultos] = useState(2);
  const [menores, setMenores] = useState(0);

  const updateEdadesMenores = (event) => {
    actualizarEdadesMenores(event, habitacion);
  };

  const updateAdultos = (val) => {
    setAdultos(val);
    actualizarAdultos(val, habitacion);
  };

  const updateMenores = (val) => {
    setMenores(val);
    actualizarMenores(val, habitacion);
  };

  const inputsMenores = [];
  if (listaHabitaciones[habitacion].menores > 0) {
    let indice = 0;
    for (indice = 0; indice < listaHabitaciones[habitacion].menores; indice++) {
      inputsMenores.push(
        <InputMenor
          key={indice}
          actualizarEdadesMenores={updateEdadesMenores}
          inputNumber={indice}
          valor={listaHabitaciones[habitacion].listaMenores[indice]}
        />
      );
    }
  }

  return (
    <div className='panel panel-default'>
      <div className='font-medium'>
        {`${t('searcher.room')} ${habitacion + 1}`}
      </div>
      <div>
        <div className='mayores'>
          <div className='descripcion-numerico text-xs'>
            {t('searcher.adults')}
          </div>
          <NumericInput
            style={{ wrap: { width: '100%' } }}
            onChange={updateAdultos}
            mobile
            className='w-full'
            value={listaHabitaciones[habitacion].adultos}
            min={1}
            max={4 - menores}
          />
        </div>
        <div className='menores'>
          <div className='descripcion-numerico text-xs'>
            {t('searcher.minors')}
          </div>
          <NumericInput
            style={{ wrap: { width: '100%' } }}
            onChange={updateMenores}
            mobile
            className='w-full'
            value={listaHabitaciones[habitacion].menores}
            min={0}
            max={4 - adultos}
          />
        </div>
      </div>
      <hr role='separator' className='divider' />
      <div className='row'>{inputsMenores}</div>
      <span className='text-xs '>{t('searcher.maxRoom')}</span>
      <div className='clearfix' />
    </div>
  );
};

export default withTranslation(['layout'])(Habitacion);
